import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Overview from "./Ops.Sms.Overview";

const Sms = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/sms"
      render={() => <Redirect to={`/snapscan/ops/sms/overview`} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/sms/overview"
      render={() => <Overview {...props} />}
    />
  </Switch>
);

export default Sms;
